import React, {Component} from 'react';
import {Empty, message} from 'antd';
import {Redirect} from 'react-router';
import './goods.less';

export default class Goods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      part: [], // 一级类的列表
      partList: [], // 类的商品列表
      redirect: false,
      identity: false,
    };
  }

  componentWillMount() {
    if (window.localStorage.getItem('identity') === '0') {
      this.setState({identity: true});
    } else {
      const isLogin = window.common.loginOut(this);
      if (isLogin) {
        window.localStorage.getItem('PKEY') ? this.getHomepage() : this.props.history.push('/login');
      } else {
        message.error('登录信息失效，请重新登录');
      }
    }
  }

  // 首页信息
  getHomepage() {
    window.api('goods.homepage', {}).then(res => {
      const info = res.hot_category;
      const part = [];
      const partList = [];

      const sourceCMS = window.localStorage.getItem('sourceCMS') || '0';

      info.forEach((item) => {
        // 当sourceCMS为1时，只保留流量产品（goods_property为3）
        if (sourceCMS === '1') {
          const flowGoods = item.goods.filter(good => good.goods_property === 3);
          if (flowGoods.length > 0) {
            part.push(item);
            partList.push(flowGoods);
          }
        } else {
          part.push(item);
          partList.push(item.goods);
        }
      });

      this.setState({part, partList});
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }

  // 跳转到搜索页
  toSearchDetail = (id) => {
    this.props.history.push('/searchDetail', {type: 'category', id});
  }

  // 跳转到详情页
  toDetail = (id, type) => {
    this.props.history.push('/goodsDetail', {id, type: type === 1 ? 'goods' : 'setMeal'});
  }

  render() {
    const {identity, redirect} = this.state;
    if (identity) return (<Redirect to="/main" />);
    if (redirect) return (<Redirect to="/login" />);
    const {part, partList} = this.state;
    return (
      <div className="sku">
        {
          partList.length > 0 ? (
            part.map((item, index) => (
              <section className="sku-block" key={index} hidden={partList[index].length === 0}>
                <h3 className="sku-cat-title" onClick={() => this.toSearchDetail(item.id)}>{item.goods_category_name}</h3>
                <ul className="sku-list">
                  {
                    partList[index].map(($0, $1) => (
                      <li key={$1} onClick={() => this.toDetail($0.id, $0.goods_type)}>
                        <img src={$0.goods_picture} alt={$0.goods_name} />
                        <div className="sku-cont">
                          <div className="price">
                            <p><em>¥</em>{Number($0.discount_price).toFixed(2)}</p>
                            {$0.discount_price !== $0.sale_price && <p className='sale'>¥{Number($0.sale_price).toFixed(2)}</p>}
                          </div>
                          <h2>{$0.goods_name}</h2>
                        </div>
                      </li>
                    ))
                  }
                </ul>
              </section>
            ))) : (
            <div className="sku-empty">
              <Empty description="暂无商品" />
            </div>
          )
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/frontEnd/goods/goods.jsx